import { FILTERSET_TARGET_MODEL_MAPPINGS } from './filtersetTargetModelMappings';
import { logger } from '@/shared/lib/logger';

export type TargetModel =
  | 'company'
  | 'metaroute'
  | 'reimbursement'
  | 'route'
  | 'run'
  | 'run_status'
  | 'trip'
  | 'user'
  | 'vehicle';

export type FilterTargetModelKey =
  | TargetModel
  | 'providers'
  | 'reimbursements'
  | 'routes'
  | 'runs'
  | 'runStatus'
  | 'schedules'
  | 'trips'
  | 'users'
  | 'vehicles';

export const FILTER_TARGET_MODEL_MAP: Record<FilterTargetModelKey, TargetModel> = {
  company: 'company',
  metaroute: 'metaroute',
  providers: 'company',
  reimbursement: 'reimbursement',
  reimbursements: 'reimbursement',
  route: 'route',
  routes: 'route',
  run: 'run',
  runs: 'run',
  run_status: 'run_status',
  runStatus: 'run_status',
  schedules: 'metaroute',
  trip: 'trip',
  trips: 'trip',
  user: 'user',
  users: 'user',
  vehicle: 'vehicle',
  vehicles: 'vehicle',
};

export const resolveFilterTargetModel = (currentPage: string): string => {
  const mappedTargetModel = FILTER_TARGET_MODEL_MAP[currentPage as FilterTargetModelKey];

  if (mappedTargetModel) {
    return mappedTargetModel;
  }

  if (FILTERSET_TARGET_MODEL_MAPPINGS[currentPage]) {
    return currentPage;
  }

  logger.warn('Missing target_model mapping for page:', currentPage);
  return currentPage;
};
